import {SimplePresentation, SimplePresentationRunnerController} from "../../core/presentation/SimplePresentationRunner";
import {TimelineLite} from "gsap";
import {HOTB} from "../HOTB";
import {GameConfig} from "../GameConfig";

export class TopReelDeadPresentation implements SimplePresentation {
    private _mainTl: TimelineLite;

    public shouldRun(): boolean {
        let flag: boolean = false;

        if ((HOTB.model.gameData.betWayWins.length > 0) || (HOTB.model.gameData.xBombList.length > 0)) {
            flag = true;
        }

        return flag;
    }

    public start(controller: SimplePresentationRunnerController): void {
        /*controller.setSkipCallback((): void => {
            this.onSkip();
        });*/

        this._mainTl = new TimelineLite({
            // delay: 0.2,
            onComplete: (): void => {
                this._mainTl.kill();
                controller.finish();
            }
        });

        this._mainTl.add(HOTB.topReel.removeDeadFeatures());
    }

    private onSkip(): void {
        GameConfig.isDeadSkipped = true;
        this._mainTl.progress(1);
        // this._mainTl.timeScale(5);
    }
}